import { styled } from 'styles/stitches.config'
import { Avatar as AvatarChakra } from '@chakra-ui/react'

import ImageNext from 'next/image'
import Text from 'components/Typography/Text'
import { rem } from 'polished'

export const CardLeaf = styled('div', {
  // maxHeight: 468,

  borderRadius: '0 100px 0 100px',
  border: 'solid 1px',
  borderColor: '$emerald500',
  overflow: 'hidden',
  cursor: 'pointer',
  transition: 'all 0.3s',

  '&:hover': {
    background: '$emerald50',
    transition: 'all 0.3s',
  },
})

export const Figure = styled('figure', {
  position: 'relative',

  height: 230,

  '@md': {
    height: 280,
  },
})

export const Image = styled('img', {
  width: '100%',
  objectFit: 'cover',
  height: '100%',
})

export const Content = styled('div', {
  padding: '30px 27px',

  h3: {
    fontSize: '20px !important',
  },
})

export const Time = styled('time', {
  marginBottom: 16,
  padding: '4px 8px',
  display: 'inline-block',

  color: '$white',
  background: '$emerald500',
  fontFamily: '$manrope',
  fontSize: 13,
  borderRadius: 4,
})

export const AuthorWrap = styled('div', {
  display: 'flex',
  alignItems: 'center',
  marginTop: 20,
  marginLeft: 15,
})

export const Avatar = styled(AvatarChakra, {
  overflow: 'hidden',
})

export const Author = styled(Text, {
  color: '$grey600',
  marginLeft: 8,
})
